import { Tooltip } from "@mui/material"
import React from "react"
import { getSplitTextWithDots } from "./helpers"
import { useStyles } from "./styles"

interface Props {
  text: string
  symbolsLimit?: number
  firstLetterLower?: boolean
  children: (text: string) => React.ReactElement
}

const LongTextTooltip: React.FC<Props> = ({
  text,
  symbolsLimit = 20,
  firstLetterLower = true,
  children
}) => {
  const { classes } = useStyles({ firstLetterLower })
  const splitText = getSplitTextWithDots(text, symbolsLimit)

  return (
    <>
      {splitText ? (
        <Tooltip
          title={text}
          placement="top"
          classes={{ tooltip: classes.tooltip }}
        >
          {children(splitText)}
        </Tooltip>
      ) : (
        children(text)
      )}
    </>
  )
}

export default LongTextTooltip
